export enum HealthConditionOptionId {
  HIGH_BLOOD_PRESSURE = "highBloodPressure",
  TYPE1_DIABETES = "type1Diabetes",
  TYPE2_DIABETES = "type2Diabetes",
  GESTATIONAL_DIABETES = "gestationalDiabetes",
  DEPRESSION_OR_ANXIETY = "depressionOrAnxiety",
  ABNORMAL_CHOLESTEROL = "abnormalCholesterol",
  LOW_TESTOSTERONE = "lowTestosterone",
  PCOS_OR_FERTILITY_PROBLEMS = "pcosOrFertilityProblems",
  CANCER_UNDER_TREATMENT = "cancerUnderTreatment",
  LIVER_DISEASE = "liverDisease",
  HEART_DISEASE = "heartDisease",
  OSTEOARTHRITIS = "osteoarthritis",
  SLEEP_PROBLEMS = "sleepProblems",
  KIDNEY_DISEASE = "kidneyDisease",
  NONE = "none",
}

export enum HealthGoal {
  LOSING_WEIGHT = "losingWeight",
  REDUCING_STRESS_ANXIOUS_FEELINGS = "reducingStressAnxiousFeelings",
}

export enum DiabetesTypeOptionId {
  TYPE1 = "type1",
  TYPE2 = "type2",
  GESTATIONAL = "gestational",
  UNSURE = "unsure",
}

export enum NoomMedMoreOptionsSelection {
  MED = "med",
  OTHER = "other",
}

export enum NoomMedOverviewSelection {
  NEXT = "next",
  SEE_MORE_OPTIONS = "seeMoreOptions",
}

export enum PregnantSelection {
  NO = "no",
  NO_BUT_NURSING = "noButNursing",
  NO_BUT_PLANNING = "noButPlanning",
  YES = "yes",
}

export enum PrimaryCareProviderSelection {
  YES = "yes",
  NO = "no",
}
